export interface AlertModel {
  show: boolean;
  style: string;
  text: string;
  meta: string | null | undefined
}
